import { render } from "./PersonTreeCard.vue?vue&type=template&id=10645a8f&scoped=true"
import script from "./PersonTreeCard.vue?vue&type=script&lang=js"
export * from "./PersonTreeCard.vue?vue&type=script&lang=js"

import "./PersonTreeCard.vue?vue&type=style&index=0&id=10645a8f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10645a8f"]])

export default __exports__